module.exports = __webpack_public_path__ + "static/media/logo_total_white.0c1d1ce0.svg";